import { useQueryClient } from 'react-query';
import { AI_RECOMMENDATION_QUERY_KEY } from './useAIRecommendation';

export function useInvalidateAIRecommendationCache() {
  const queryClient = useQueryClient();
  return {
    invalidateForAlarm: (alarmId: string) => {
      queryClient.removeQueries([AI_RECOMMENDATION_QUERY_KEY, alarmId]);
    },
  };
}

export default useInvalidateAIRecommendationCache;
